module.exports = __webpack_public_path__ + "static/img/shangye.b369d752.png";